export default class ResourceModel {
    work_orders_id: number;
    additional_type: string;
    reason: string;
    manpowers: {
        qty: number;
        scope_of_work: string;
    }[];
    materials: {
        proposed_qty: number;
        remaining_qty: number;
        material_id: number;
        description: string;
        uom: string;
        sparepart_no: string;
        item_name: string;
    }[];
    constructor(data: Partial<ResourceModel> = {}) {
        this.work_orders_id = data.work_orders_id || 0;
        this.additional_type = data.additional_type || "";
        this.reason = data.reason || "";
        this.manpowers = data.manpowers || [];
        this.materials = data.materials || [];
    }
}
